import { formatCount } from '@wit-support/ui';
import { LAYOUT_LABELS } from './naming.js';
const op = (label, kind = 'other') => ({ label, kind });
/**
 * Действие по `operation`: операция порта (`previewBatch`) или инструмент
 * нейронки (`launch_batch_preview`). Вид (`kind`) задаёт итог строки и не
 * зависит от русской подписи.
 */
const OPERATIONS = {
    previewBatch: op('Проверка плана', 'preview'),
    launch_batch_preview: op('Проверка плана', 'preview'),
    batchSpend: op('Расчёт расхода', 'view'),
    createBatch: op('Создание пачки', 'create'),
    launch_batch_create: op('Создание пачки', 'create'),
    executeBatch: op('Выполнение пачки', 'execute'),
    launch_batch_execute: op('Выполнение пачки', 'execute'),
    cancelBatch: op('Отмена пачки', 'cancel'),
    launch_batch_cancel: op('Отмена пачки', 'cancel'),
    activateLaunch: op('Включение', 'activate'),
    launch_activate: op('Включение', 'activate'),
    pauseLaunch: op('Пауза', 'pause'),
    launch_pause: op('Пауза', 'pause'),
    retryLaunch: op('Повтор запуска'),
    launch_retry: op('Повтор запуска'),
    rollbackLaunch: op('Откат', 'rollback'),
    launch_rollback: op('Откат', 'rollback'),
    reverifyLaunch: op('Перепроверка'),
    launch_reverify: op('Перепроверка'),
    createTemplate: op('Создание шаблона'),
    launch_template_create: op('Создание шаблона'),
    updateTemplate: op('Изменение шаблона'),
    launch_template_update: op('Изменение шаблона'),
    archiveTemplate: op('Архив шаблона'),
    launch_template_archive: op('Архив шаблона'),
    unarchiveTemplate: op('Возврат шаблона из архива'),
    duplicateTemplate: op('Копия шаблона'),
    launch_template_duplicate: op('Копия шаблона'),
    templateFromCampaign: op('Шаблон из кампании'),
    launch_template_from_campaign: op('Шаблон из кампании'),
    duplicateCampaign: op('Копия кампании'),
    launch_campaign_duplicate: op('Копия кампании'),
    putProfile: op('Изменение профиля кабинета'),
    launch_account_profile_put: op('Изменение профиля кабинета'),
    namingSample: op('Пример названий', 'view'),
    launch_naming_sample: op('Пример названий', 'view'),
    initUpload: op('Загрузка файла'),
    signUploadParts: op('Загрузка файла'),
    completeUpload: op('Загрузка файла'),
    abortUpload: op('Отмена загрузки файла'),
    archiveAsset: op('Архив файла'),
    launch_media_archive: op('Архив файла'),
    retryMedia: op('Повтор переноса файла'),
    launch_media_retry: op('Повтор переноса файла'),
    createCountryList: op('Список стран: создание'),
    launch_country_list_create: op('Список стран: создание'),
    updateCountryList: op('Список стран: изменение'),
    launch_country_list_update: op('Список стран: изменение'),
    deleteCountryList: op('Список стран: удаление'),
    launch_country_list_delete: op('Список стран: удаление'),
    // чтения: попадают в журнал только при неудаче
    getBatch: op('Просмотр пачки', 'view'),
    launch_batch_get: op('Просмотр пачки', 'view'),
    listBatches: op('Список пачек', 'view'),
    launch_batches_list: op('Список пачек', 'view'),
    launch_batch_find: op('Поиск пачки', 'view'),
    getLaunch: op('Просмотр запуска', 'view'),
    launch_get: op('Просмотр запуска', 'view'),
    getTemplate: op('Просмотр шаблона', 'view'),
    getDuplicate: op('Просмотр копии кампании', 'view'),
    launch_template_get: op('Просмотр шаблона', 'view'),
    listTemplates: op('Список шаблонов', 'view'),
    launch_templates_list: op('Список шаблонов', 'view'),
    getProfile: op('Просмотр кабинета', 'view'),
    launch_account_get: op('Просмотр кабинета', 'view'),
    listProfiles: op('Список кабинетов', 'view'),
    listAdAccounts: op('Список кабинетов', 'view'),
    launch_accounts: op('Список кабинетов', 'view'),
    getAsset: op('Просмотр файла', 'view'),
    launch_media_asset_get: op('Просмотр файла', 'view'),
    listMedia: op('Медиатека', 'view'),
    launch_media_list: op('Медиатека', 'view'),
    listMediaSources: op('Выбор медиа', 'view'),
    launch_media_sources: op('Выбор медиа', 'view'),
    registry: op('Реестр полей', 'view'),
    launch_registry: op('Реестр полей', 'view'),
    health: op('Состояние конструктора', 'view'),
    launch_builder_status: op('Состояние конструктора', 'view'),
};
const READ_RE = /^(get|list|search|resolve|preview|label|funnel|campaign)|^launch_(.*_)?(get|list|search|find|sources|labels|locales|posts|image)s?$/;
function opInfo(operation) {
    return (OPERATIONS[operation] ??
        (READ_RE.test(operation) ? op('Просмотр данных', 'view') : op('Другое действие')));
}
export function operationLabel(operation) {
    return opInfo(operation).label;
}
function opKind(operation) {
    return opInfo(operation).kind;
}
// --- откуда / где остановилось ------------------------------------------------
export function sourceLabel(source) {
    return source === 'mcp' ? 'нейронка' : 'админка';
}
export function stoppedAtLabel(stoppedAt) {
    switch (stoppedAt) {
        case 'admin':
            return 'в админке';
        case 'mcp':
            return 'в нейронке';
        case 'auto_ads':
            return 'в сервисе рекламы';
        case 'meta':
            return 'в Meta';
        default:
            return '—';
    }
}
const ISSUES_F = ['ошибка', 'ошибки', 'ошибок'];
const LAUNCHES_F = ['запуск', 'запуска', 'запусков'];
const WHO_CAN = 'супервайзер и владелец';
/**
 * Счётчики замечаний строки. Новые строки несут полные `errorsCount` /
 * `warningsCount` в `summary` (посчитаны до усечения списка до 20). У старых
 * строк считаем по списку только если он полный; иначе «ошибок» — неизвестно,
 * и экран не утверждает «без ошибок».
 */
export function issueCounts(row) {
    const list = row.issues ?? [];
    const total = row.issuesCount;
    const s = row.summary;
    const e = s?.['errorsCount'];
    const w = s?.['warningsCount'];
    const truncated = total != null && total > list.length;
    if (typeof e === 'number' && typeof w === 'number') {
        return { errors: e, warnings: w, total, truncated };
    }
    if (!truncated) {
        return {
            errors: list.filter((i) => i.severity === 'error').length,
            warnings: list.filter((i) => i.severity === 'warning').length,
            total,
            truncated,
        };
    }
    return { errors: null, warnings: null, total, truncated };
}
/**
 * «Ошибочная попытка» — единое правило для фильтра «Только ошибки» (сервер,
 * `outcome=failed` в `ads-request-log-query-pg.ts`) и для бейджа: исход не
 * `ok`, ИЛИ `summary.errorsCount > 0`, а у старых строк без счётчика —
 * в сохранённых замечаниях есть severity error. Счётчик главнее списка.
 */
export function isFailedAttempt(row) {
    if (row.outcome !== 'ok')
        return true;
    const counter = row.summary?.['errorsCount'];
    if (typeof counter === 'number')
        return counter > 0;
    return (row.issues ?? []).some((i) => i.severity === 'error');
}
/** Итог попытки — коротко, для таблицы и карточки. */
export function outcomeView(row) {
    const v = baseOutcomeView(row);
    // ответ 200 с ошибками в плане — не «успех», как и в фильтре «Только ошибки»
    if (v.tone === 'success' && isFailedAttempt(row))
        return { tone: 'danger', text: 'Есть ошибки' };
    return v;
}
function baseOutcomeView(row) {
    const kind = opKind(row.operation);
    switch (row.outcome) {
        case 'ok':
            switch (kind) {
                case 'preview': {
                    // проверка плана отвечает 200 и с ошибками в плане — итог по замечаниям
                    const c = issueCounts(row);
                    if (c.errors === null) {
                        return {
                            tone: 'warning',
                            text: `Замечаний ${c.total ?? 0}, список неполный`,
                        };
                    }
                    if (c.errors > 0) {
                        return { tone: 'danger', text: `${formatCount(c.errors, ISSUES_F)} в плане` };
                    }
                    return { tone: 'success', text: 'План без ошибок' };
                }
                case 'create':
                    return { tone: 'success', text: 'Принята' };
                case 'execute':
                    return { tone: 'success', text: 'Выполнение запущено' };
                case 'cancel':
                    return { tone: 'success', text: 'Отменена' };
                case 'activate':
                    return { tone: 'success', text: 'Включён' };
                case 'pause':
                    return { tone: 'success', text: 'На паузе' };
                case 'rollback':
                    return { tone: 'success', text: 'Откачен' };
                case 'view':
                default:
                    return { tone: 'success', text: 'Готово' };
            }
        case 'rejected': {
            if (kind === 'preview' && (row.issuesCount ?? 0) > 0) {
                const c = issueCounts(row);
                if (c.errors === null) {
                    return { tone: 'danger', text: `Замечаний ${c.total ?? 0}, список неполный` };
                }
                if (c.errors > 0) {
                    return { tone: 'danger', text: `${formatCount(c.errors, ISSUES_F)} в плане` };
                }
            }
            const code = row.errorCode ?? '';
            if (code === 'template-version-conflict')
                return { tone: 'danger', text: 'Шаблон изменён' };
            if (code === 'preview-stale')
                return { tone: 'danger', text: 'План устарел' };
            if (code === 'rate-limited')
                return { tone: 'warning', text: 'Лимит Meta, повторим позже' };
            // старт прошёл — это не поломка, а условие: включить можно с подтверждением (E-2 P2-7)
            if (code === 'start-passed') {
                return { tone: 'warning', text: ISSUE_TEXTS['start-passed'].plain };
            }
            if (row.stoppedAt === 'meta')
                return { tone: 'danger', text: 'Meta отказала' };
            return { tone: 'danger', text: 'Сервис рекламы отказал' };
        }
        case 'forbidden':
            return { tone: 'danger', text: `Нет прав — могут ${WHO_CAN}` };
        case 'invalid':
            return { tone: 'danger', text: 'Данные не прошли проверку' };
        case 'unavailable':
            return { tone: 'warning', text: 'Сервис рекламы не ответил' };
        case 'unknown':
            return row.stoppedAt === 'meta'
                ? { tone: 'warning', text: 'Meta не ответила' }
                : { tone: 'warning', text: 'Результат неизвестен' };
        case 'error':
            if (row.stoppedAt === 'auto_ads')
                return { tone: 'warning', text: 'Сервис рекламы не ответил' };
            if (row.stoppedAt === 'meta')
                return { tone: 'warning', text: 'Сбой при обращении к Meta' };
            return { tone: 'warning', text: 'Сбой админки' };
    }
}
/** Развёрнутое «что произошло» одним-двумя предложениями. */
export function outcomeExplanation(row) {
    const kind = opKind(row.operation);
    switch (row.outcome) {
        case 'ok': {
            if (kind === 'preview') {
                const c = issueCounts(row);
                if (c.errors === null) {
                    return `Проверка ответила, но в строке сохранён неполный список замечаний (всего ${c.total ?? 0}), поэтому сказать, есть ли в плане ошибки, нельзя. Проверьте план заново.`;
                }
                if (c.errors > 0) {
                    return 'Проверка прошла, но в плане есть ошибки: создать пачку с ними нельзя. Причины ниже.';
                }
            }
            return kind === 'create'
                ? 'Пачка принята. Создание в Meta идёт после ответа — итог по каждому запуску смотрите в самой пачке.'
                : 'Действие выполнено без ошибок.';
        }
        case 'rejected': {
            const why = refusalReason(row);
            if (why != null)
                return `${why}.`;
            return row.stoppedAt === 'meta'
                ? 'Meta отказала в выполнении действия. Причина — в запуске или пачке.'
                : 'Сервис рекламы не принял запрос. Причины ниже, если сервис их назвал.';
        }
        case 'forbidden':
            return `У автора не хватило прав на это действие: его могут выполнять ${WHO_CAN}. Ничего не изменилось.`;
        case 'invalid':
            return 'Запрос не прошёл проверку ещё до сервиса рекламы — например, неверно заполнено поле. Ничего не изменилось.';
        case 'unavailable':
            return 'Сервис рекламы не ответил. Чтение можно повторить; у изменений проверьте результат в самой пачке.';
        case 'unknown':
            return 'Ответа не было, поэтому неизвестно, выполнилось ли действие. Проверьте результат в Meta или в пачке, прежде чем повторять.';
        case 'error':
            return 'Произошёл сбой при обработке запроса. Подробности для поддержки — ниже.';
    }
}
const KIND_RU = {
    template: 'шаблон',
    batch: 'пачка',
    launch: 'запуск',
    account: 'кабинет',
    other: '',
};
/** Объект попытки словами; `null` — объекта нет (или его не удалось назвать). */
export function whatText(row, formatDate) {
    const w = row.what;
    if (!w)
        return null;
    if (w.kind === 'batch') {
        return w.createdAt ? `пачка от ${formatDate(w.createdAt)}` : (w.name ?? 'пачка');
    }
    if (w.name)
        return KIND_RU[w.kind] ? `${KIND_RU[w.kind]} «${w.name}»` : `«${w.name}»`;
    return KIND_RU[w.kind] ? `${KIND_RU[w.kind]} (название недоступно)` : null;
}
/** Живое состояние пачки рядом с итогом создания: «1 из 2 запусков с ошибкой». */
export function batchLiveText(row) {
    const b = row.what?.kind === 'batch' ? row.what.batch : null;
    if (!b || b.launches <= 0)
        return null;
    // E-2 P3: «пачка: 3, ошибок пока нет» было не понять — что за тройка
    const launches = formatCount(b.launches, LAUNCHES_F);
    if (b.failed > 0)
        return `в пачке ${launches}, с ошибкой — ${b.failed}`;
    return `в пачке ${launches}, ошибок пока нет`;
}
// --- «Что отправлено» ----------------------------------------------------------
const BATCH_MODE_RU = { draft: 'черновик', execute: 'сразу в работу' };
const ACTIVATION_RU = { auto: 'автоматически', manual: 'вручную' };
/** Сводка отправленного из белого списка `summary`; пустая — если нечего показать. */
export function summaryLines(row) {
    const s = row.summary;
    if (!s)
        return [];
    const out = [];
    const num = (key, label) => {
        const v = s[key];
        if (typeof v === 'number')
            out.push({ label, value: String(v) });
    };
    num('accounts', 'Кабинетов');
    num('items', 'Креативов');
    num('copies', 'Копий');
    const layout = s['layout'];
    if (typeof layout === 'string') {
        out.push({ label: 'Раскладка', value: LAYOUT_LABELS[layout] ?? 'другая' });
    }
    num('groups', 'Групп шаблона');
    const bidStep = s['bidStep'];
    if (typeof bidStep === 'number' && bidStep !== 0) {
        out.push({ label: 'Шаг ставки', value: String(bidStep) });
    }
    const mode = s['mode'];
    if (typeof mode === 'string' && BATCH_MODE_RU[mode]) {
        out.push({ label: 'Режим', value: BATCH_MODE_RU[mode] });
    }
    const activation = s['activation'];
    if (typeof activation === 'string' && ACTIVATION_RU[activation]) {
        out.push({ label: 'Включение', value: ACTIVATION_RU[activation] });
    }
    if (s['late'] === true)
        out.push({ label: 'Старт', value: 'после прошедшего времени' });
    if (s['force'] === true)
        out.push({ label: 'Включено', value: 'несмотря на расхождения' });
    const v = s['templateVersion'];
    if (typeof v === 'number' || typeof v === 'string') {
        out.push({ label: 'Версия шаблона', value: String(v) });
    }
    return out;
}
// --- «Почему»: замечания --------------------------------------------------------
/**
 * Код замечания → русский текст. `{field}` подставляется подписью поля из
 * реестра («Ставка»); без поля — общая формулировка. Незнакомый код —
 * «Замечание сервиса рекламы» (сам код — в блоке для поддержки).
 */
const ISSUE_TEXTS = {
    'required-at-launch': {
        withField: '{field} — обязательно при запуске',
        plain: 'Не заполнено обязательное поле',
    },
    required: { withField: '{field} — обязательно', plain: 'Не заполнено обязательное поле' },
    'invalid-value': {
        withField: '{field} — недопустимое значение',
        plain: 'Недопустимое значение',
    },
    'field-not-editable': {
        withField: '{field} — при запуске менять нельзя',
        plain: 'Это поле при запуске менять нельзя',
    },
    'budget-below-minimum': { plain: 'Бюджет меньше минимального, который принимает Meta' },
    'bid-step-without-cap': {
        plain: 'Шаг ставки работает только со стратегией «Предельная ставка» или «Цель по цене»',
    },
    'bid-step-clamped': { plain: 'Две копии получили одинаковую ставку из-за границ' },
    'bid-step-large': { plain: 'Ставка крайней копии сильно отличается от общей' },
    'adset-name-numbered': { plain: 'К названиям групп объявлений добавлен номер' },
    'name-shape-literal': {
        plain: 'В названии кампании написана форма, которая не совпадёт с итоговой',
    },
    'gender-with-advantage': { plain: 'При Advantage+ аудитории пол — только подсказка для Meta' },
    'group-count': { plain: 'Групп шаблона должно быть не меньше двух и не больше десяти' },
    'group-label-not-latin': { plain: 'Название группы — только латиница, цифры и простые знаки' },
    'group-label-duplicate': { plain: 'Две группы шаблона с одинаковым названием' },
    'group-key-unknown': { plain: 'Шаблон изменили в другой вкладке — группа не найдена' },
    'group-field-not-allowed': { plain: 'Это поле задаётся для всей кампании, а не для группы' },
    'group-bid-unused': { plain: 'У группы своя ставка, но стратегия ставку не использует' },
    'group-field-hidden': { plain: 'Значение группы не действует при выбранной стратегии' },
    'group-same-as-base': { plain: 'Группа шаблона ничем не отличается от общего' },
    'group-identical': { plain: 'Две группы шаблона одинаковые' },
    'group-advantage-default-off': {
        plain: 'Advantage+ аудитория выключена в группах со своей аудиторией',
    },
    'group-advantage-overlap': {
        plain: 'Группы с Advantage+ будут сильно пересекаться — сравнить их будет трудно',
    },
    'template-has-no-groups': { plain: 'У шаблона нет групп — выбор групп нужно убрать' },
    'group-not-in-template': { plain: 'Такой группы нет в шаблоне' },
    'groups-all-removed': { plain: 'Не выбрана ни одна группа шаблона' },
    'group-edit-excluded': { plain: 'Правка относится к группе, которую сняли с запуска' },
    'group-budget-cbo': { plain: 'При CBO бюджет общий на кампанию — суммы групп не нужны' },
    'group-budget-large': { plain: 'Бюджет группы намного больше общего — проверьте сумму' },
    'group-overrides-launch-value': {
        plain: 'Изменение при запуске перекрыто значением группы шаблона',
    },
    'spend-unusual': { plain: 'Дневной расход больше обычного для этого шаблона' },
    'spend-total': { plain: 'Итоговый дневной расход отличается от суммы в поле бюджета' },
    'too-many-adsets': { plain: 'Групп объявлений получается больше допустимого' },
    'groups-single': { plain: 'Выбрана одна группа шаблона' },
    'ads-total': { plain: 'Объявлений в Meta больше, чем креативов' },
    'audience-slot-unmapped': { plain: 'Аудитория не задана в профиле кабинета' },
    'country-list-not-found': { plain: 'Список стран не найден' },
    'multi-lal': { plain: 'Выбрано несколько похожих аудиторий сразу' },
    'preview-stale': { plain: 'План устарел — проверьте его заново' },
    'template-version-conflict': { plain: 'Шаблон изменили, пока шла работа' },
    'verify-has-errors': { plain: 'В плане остались ошибки' },
    'start-passed': { plain: 'Время старта прошло — включить можно вручную, с подтверждением' },
    'start-too-close': { plain: 'До старта слишком мало времени' },
    'ad-conversion-domain-absent': { plain: 'Домен конверсий не задан — объявления без домена' },
    'rate-limited': { plain: 'Meta ограничила число запросов' },
    'meta-error': { plain: 'Meta вернула ошибку' },
    // причины отказа плана и запуска (приёмка E-2, P2-6): раньше эти коды
    // выглядели как «Замечание сервиса рекламы», а настоящая причина была только
    // в блоке «Для поддержки»
    'account-not-allowed': {
        plain: 'Этот кабинет не разрешён в шаблоне — добавьте его в шаблон или выберите другой',
    },
    'account-not-found': { plain: 'Кабинет не найден — возможно, его убрали из списка' },
    'account-dropped': { plain: 'Кабинет убрали из запуска' },
    'account-profile-missing': {
        plain: 'У кабинета не заполнен профиль — заполните его на странице кабинета',
    },
    'template-archived': { plain: 'Шаблон в архиве — верните его из архива или выберите другой' },
    'template-missing': { plain: 'Шаблон не найден' },
    'template-changed': { plain: 'Шаблон изменили после проверки плана — проверьте план заново' },
    'too-many-launches': { plain: 'Запусков в пачке больше допустимого — уменьшите число' },
    'batch-cancelled': { plain: 'Пачка отменена' },
    'drift-before-start': {
        plain: 'Перед стартом в Meta что-то изменилось — запуск на паузе до чистой сверки',
    },
    'groups-appeared': { plain: 'В шаблоне появились группы — проверьте план заново' },
    'groups-unavailable': { plain: 'Группы шаблона сейчас недоступны' },
    'reverify-required': { plain: 'Сверка устарела — запуск нужно перепроверить' },
    'rollback-forbidden-active': {
        plain: 'Откатить включённый запуск нельзя — сначала поставьте его на паузу',
    },
    'late-start-not-applicable': {
        plain: 'Подтверждение позднего старта здесь не нужно: старт ещё не прошёл или запуск не ждёт включения',
    },
    'schedule-stale': { plain: 'Расписание устарело — проверьте план заново' },
    'schedule-recomputed': { plain: 'Старт сдвинут позже — прежнее время прошло' },
    'start-reset': { plain: 'Время старта сброшено — выберите новое время старта' },
    'currency-unsupported': { plain: 'Валюта кабинета не поддерживается' },
    'no-accounts': { plain: 'Не выбран ни один кабинет' },
    'no-items': { plain: 'Не выбран ни один пост или креатив' },
    'idempotency-key-taken': { plain: 'Такая пачка уже создавалась — откройте её в списке пачек' },
    'name-duplicate': {
        plain: 'Имя кампании совпадает с другой — добавьте в шаблон имени различающий токен',
    },
    'post-missing': { plain: 'Пост не найден' },
    'media-missing': { plain: 'Файл не найден в медиатеке' },
    'media-not-found': { plain: 'Файл не найден в медиатеке' },
    'invalid-state': { plain: 'Действие недоступно в текущем состоянии' },
    'invalid-values': { plain: 'В плане есть недопустимые значения' },
    'campaign-override-not-allowed': {
        withField: 'Имя копии можно задать только у шаблона-копии кампании',
        plain: 'Имя копии можно задать только у шаблона-копии кампании',
    },
    'remote-validation': { plain: 'Meta отклонила проверку плана' },
    'builder-disabled': { plain: 'Конструктор запусков сейчас выключен' },
    'meta-rate-limited': { plain: 'Meta ограничила число запросов — повторите позже' },
    'meta-unavailable': { plain: 'Meta сейчас не отвечает — повторите позже' },
    'funnel-settings-catalog-unavailable': { plain: 'Настройки воронки сейчас недоступны' },
};
export const UNKNOWN_ISSUE_TEXT = 'Замечание сервиса рекламы';
/**
 * Причина отказа по коду отказа строки (`errorCode`), словами. Только у
 * отказов (`rejected`) и только для кодов с переводом: незнакомый код сам на
 * экран не попадает — вместо него общая фраза в `outcomeExplanation`.
 */
export function refusalReason(row) {
    if (row.outcome !== 'rejected' || row.errorCode == null)
        return null;
    return ISSUE_TEXTS[row.errorCode]?.plain ?? null;
}
function lowerFirst(s) {
    return s.length > 0 ? s.charAt(0).toLowerCase() + s.slice(1) : s;
}
/** Замечания строки словами: одинаковые сведены, ошибки идут перед предупреждениями. */
export function issueViews(issues, fieldLabel) {
    const byKey = new Map();
    for (const i of issues ?? []) {
        const entry = ISSUE_TEXTS[i.code];
        const label = i.fieldKey != null ? fieldLabel(i.fieldKey) : null;
        const base = entry
            ? label != null && entry.withField
                ? entry.withField.replace('{field}', label)
                : entry.plain
            : UNKNOWN_ISSUE_TEXT;
        const text = i.groupKey != null && entry ? `Группа шаблона: ${lowerFirst(base)}` : base;
        const key = `${i.severity}|${i.code}|${text}`;
        const hit = byKey.get(key);
        if (hit)
            hit.count += 1;
        else
            byKey.set(key, { key, severity: i.severity, text, count: 1, code: i.code });
    }
    return [...byKey.values()].sort((a, b) => Number(b.severity === 'error') - Number(a.severity === 'error'));
}
/** «1,2 с» — длительность попытки. */
export function durationText(ms) {
    if (ms == null)
        return null;
    if (ms < 1000)
        return `${ms} мс`;
    return `${(ms / 1000).toFixed(1).replace('.', ',')} с`;
}
export const PERIOD_LABELS = {
    today: 'Сегодня',
    '7': '7 дней',
    '30': '30 дней',
    '90': '90 дней',
    custom: 'Свой период',
};
/** Сдвиг пояса `tz` от UTC в миллисекундах на момент `at`. */
function tzOffsetMs(at, tz) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).formatToParts(new Date(at));
    const get = (t) => Number(parts.find((p) => p.type === t)?.value ?? 0);
    const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
    return asUtc - Math.floor(at / 1000) * 1000;
}
/** Момент (UTC ISO) начала календарного дня `ymd` («2026-10-26») в поясе `tz`. */
export function zonedDayStartIso(ymd, tz) {
    const [y, m, d] = ymd.split('-').map(Number);
    const guess = Date.UTC(y, m - 1, d);
    let t = guess - tzOffsetMs(guess, tz);
    t = guess - tzOffsetMs(t, tz); // на границе перехода на летнее время смещение другое
    return new Date(t).toISOString();
}
/** Дата `now` в поясе `tz` как «ГГГГ-ММ-ДД». */
export function zonedYmd(now, tz) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date(now));
}
/** Сдвиг даты «ГГГГ-ММ-ДД» на `days` дней. */
export function shiftYmd(ymd, days) {
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}
/**
 * Границы периода в UTC. «Сегодня» — с полуночи по `tz`; «7 дней» — сегодня
 * и шесть предыдущих дней. Свой период — включительно по обе даты, в том же
 * поясе (`to` на сервере исключающий — берём начало следующего дня).
 */
export function periodRange(period, now, tz, custom) {
    const today = zonedYmd(now, tz);
    if (period === 'custom') {
        const from = custom?.from || today;
        const to = custom?.to || today;
        return { from: zonedDayStartIso(from, tz), to: zonedDayStartIso(shiftYmd(to, 1), tz) };
    }
    const back = period === 'today' ? 0 : Number(period) - 1;
    return { from: zonedDayStartIso(shiftYmd(today, -back), tz) };
}
//# sourceMappingURL=request-log-texts.js.map